/* =============================================================
   PawShift — PDP handoff reader (from the Settle Assessment quiz)
   Fills the assessment strip + below-buy-box close ONLY when the visitor
   arrived from the quiz (URL ps_* params, or localStorage fallback).
   Display-only: no cart, no /cart/add.js, no fbq, no Appstle. If there's
   no quiz context the sections stay hidden and the PDP is unchanged.
   ============================================================= */
(function () {
  'use strict';
  if (window.__psQhInit) return;            // run once even if the section appears twice
  window.__psQhInit = true;

  var nodes = document.querySelectorAll('[data-ps-qh]');
  if (!nodes.length) return;

  function params() {
    var q = {};
    (location.search || '').replace(/^\?/, '').split('&').forEach(function (p) {
      if (!p) return;
      var i = p.indexOf('=');
      q[decodeURIComponent(p.slice(0, i))] = decodeURIComponent(p.slice(i + 1));
    });
    return q;
  }
  var q = params();
  var d = (q.ps_name || q.ps_score) ? q : null;
  if (!d) { try { d = JSON.parse(localStorage.getItem('ps_quiz_handoff') || 'null'); } catch (e) {} }
  if (!d || !(d.ps_name || d.ps_score)) return;   // no quiz context -> leave hidden

  /* Pattern hand-off — publish the dog's dominant symptom pattern so the review
     grid (ps-reviews.js) and social-proof carousel (ps-social-proof) can match
     content to the quiz. ps_pattern is the quiz's top-2 symptom codes, comma-
     joined (e.g. "separation,noise"); index 0 is the dominant pattern. We set it
     synchronously (this runs before DOMContentLoaded) AND fire an event, so the
     other scripts don't depend on load order. No quiz context => psQuiz stays
     undefined => both features fall back to their static default. */
  var patterns = (d.ps_pattern || '').split(',').map(function (p) { return p.trim(); }).filter(Boolean);
  window.psQuiz = { topPattern: patterns[0] || null, patterns: patterns };
  try { document.dispatchEvent(new CustomEvent('ps:pattern', { detail: window.psQuiz })); } catch (e) {}

  var SPEND = { 'under100':'under $100', '100-300':'$100–$300', '300-800':'$300–$800', '800-1500':'$800–$1,500', '1500':'over $1,500' };
  var HIS = { boy:'his', girl:'her' };

  var name = (d.ps_name || 'your dog').toString();
  var namePos = /s$/i.test(name) ? name + '’' : name + '’s';
  var his = HIS[d.ps_gender] || 'their';
  var dose = d.ps_dose ? (d.ps_dose + ' ' + (String(d.ps_dose) === '1' ? 'chew' : 'chews') + ' a day') : 'their daily dose';
  var spend = SPEND[d.ps_spend] || d.ps_spend || 'a fair bit';
  var score = d.ps_score || '';

  function fill(n, sel, val) { n.querySelectorAll(sel).forEach(function (e) { e.textContent = val; }); }
  nodes.forEach(function (n) {
    fill(n, '[data-qh-name]', name);
    fill(n, '[data-qh-name-pos]', namePos);
    fill(n, '[data-qh-score]', score);
    fill(n, '[data-qh-dose]', dose);
    fill(n, '[data-qh-his]', his);
    fill(n, '[data-qh-spend]', spend);
    /* Sunk-cost close: the default paragraph quotes her spend band back at her,
       which reads as false/insulting for 'under100'. Swap to the forward-looking
       variant instead of suppressing — the value frame has to survive. */
    var band = (d.ps_spend === 'under100') ? 'under100' : 'default';
    n.querySelectorAll('[data-qh-band]').forEach(function (p) {
      p.hidden = p.getAttribute('data-qh-band') !== band;
    });
    n.hidden = false;
  });

  /* Below-fold pronoun flex (Phase 2). The page ships a neutral they/their base,
     so this is a 3-state swap, not a masculine default plus a feminine override:
     no gender => the base stands. they↔he/she do NOT share verb agreement
     ("they tip over" vs "he tips over"), so each element carries WHOLE PHRASES
     in data-ps-he / data-ps-she — never a bare pronoun. */
  var g = d.ps_gender;                    // 'boy' | 'girl' | undefined
  if (g === 'boy' || g === 'girl') {
    var attr = g === 'girl' ? 'data-ps-she' : 'data-ps-he';
    document.querySelectorAll('[' + attr + ']').forEach(function (el) {
      var v = el.getAttribute(attr);
      if (v) el.textContent = v;
    });
  }

  (window.dataLayer = window.dataLayer || []).push({ event: 'ps_quiz_pdp_arrival', ps_score: score });

  /* P3 · scent continuity — trigger the buy box's OWN weight calculator so it
     recommends/selects the matching tier + price. We only click the existing
     .ps-calc__btn (same as a user tap): no cart mutation, no /cart/add.js,
     no fbq, no edit to ps-hero-2. Fires after load so the buy box is wired. */
  var WEIGHT_BTN = { 'u45':'xs', '5-18':'sm', '18-36':'md', '36plus':'lg' };
  var wcode = WEIGHT_BTN[d.ps_weight];
  if (wcode) {
    var preselect = function () {
      var btn = document.querySelector('.ps-calc__btn[data-weight="' + wcode + '"]');
      // Click unconditionally. The buy box now defaults a band (md) at init, so
      // an is-active guard here would skip the click for exactly the quiz
      // visitors whose dog IS 18-36 kg — and skipping it leaves the cards in
      // the neutral "we were told nothing" state despite the quiz having told
      // us. Re-clicking an already-active band is idempotent.
      if (btn) btn.click();
    };
    if (document.readyState === 'complete') setTimeout(preselect, 200);
    else window.addEventListener('load', function () { setTimeout(preselect, 200); });
  }
})();
